<template>
  <el-dialog
    :close-on-click-modal="false"
    title="资金转移"
    :lock-scroll="true"
    :visible.sync="dialogFormVisible"
  >
    <section v-loading="getDetailLoading">
      <el-alert
        :closable="false"
        title="温馨提示：转现的金额不能大于选择月份节余金额，也不能大于当前ETC账户剩余金额"
        type="warning" />
      <qx-custom-form
        @sub="sub"
        :noSubBtn="true"
        ref="customForm"
        :formData="formData"
        labelWidth="130px"
      >
        <!-- 剩余金额 -->
        <span slot="canTurnMoneyDouble" slot-scope="prop" class="error">
          ￥{{prop.form.canTurnMoneyDouble || 0}}
        </span>
        <!-- 订单ETC总金额 -->
        <span slot="orderMoneyDouble" slot-scope="prop" class="error">
          ￥{{prop.form.orderMoneyDouble || 0}}
        </span>
        <!-- 可转移金额 -->
        <span slot="canTurnMoneyDouble" slot-scope="prop" class="error">
          ￥{{prop.form.canTurnMoneyDouble || 0}}
        </span>
        <!-- 订单油卡总金额 -->
        <span slot="orderMoneyDouble" slot-scope="prop" class="error">
          ￥{{prop.form.orderMoneyDouble || 0}}
        </span>
        <!-- 消费总金额 -->
        <span slot="consumeMoneyDouble" slot-scope="prop" class="error">
          ￥{{prop.form.consumeMoneyDouble || 0}}
        </span>
      </qx-custom-form>
    </section>
    <section slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" @click="customFormPost" :loading="subLoading || getDetailLoading">确 定</el-button>
    </section>
  </el-dialog>
</template>

<script>
import {
  queryDriverAccountBalance,
  driverBalanceTurn,
} from 'api/getPay';
export default {
  data () {
    return {
      getDetailLoading: false, // 获取详情loading
      dialogFormVisible: false,
      subLoading: false, // 提交loading
      type: '', // add/新增 edit/修改
      merLoading: false, // 商户选项loading中
      originData: {},
      formData: {
        turnOilTypeOptions: [
          {
            label: '转现金',
            value: 1,
          },
          {
            label: '转油卡',
            value: 2,
          },
        ],
        form: [
          {
            label: '类型',
            value: 'turnType',
            type: 'radio',
            placeholder: '请选择类型',
            default: 1,
            onChange: () => {
              this.handleTurnTypeChange();
            },
            options: [
              {
                label: '油余额转移',
                value: 1,
              },
              {
                label: 'ETC余额转移',
                value: 2,
              },
            ],
          },
          {
            label: '转移方式',
            value: 'turnOilType',
            type: 'radio',
            placeholder: '请选择转移方式',
            default: 1,
            hide: false,
            onChange: () => {
              this.handleTurnOilTypeChange();
            },
          },
          {
            label: '转移月份',
            value: 'turnMonth',
            type: 'date',
            hide: false,
            placeholder: '请选择转移月份',
            onChange: () => {
              this.handleTurnMonthChange();
            },
            attr: {
              type: 'month',
            },
          },
          {
            label: '可转移金额',
            value: 'canTurnMoneyDouble',
            slot: true,
            hide: false,
          },
          {
            label: '订单油卡总金额',
            value: 'orderMoneyDouble',
            slot: true,
            hide: false,
          },
          {
            label: '消费总金额',
            value: 'consumeMoneyDouble',
            slot: true,
            hide: false,
          },
          {
            label: '转移金额',
            value: 'turnBalance',
            type: 'input',
            hide: false,
          },
          {
            label: '转移折扣',
            value: 'turnDiscountDouble',
            type: 'input',
            hide: false,
          },
          {
            label: '油卡卡号',
            value: 'turnEntityOilCard',
            type: 'input',
            hide: true,
          },
        ],
        rules: { // 表单验证规则
        },
      },
    };
  },
  methods: {
    async handleTurnMonthChange () { // 转移月份
      const turnType = this.$refs.customForm.getVal('turnType');
      const turnMonth = this.$refs.customForm.getVal('turnMonth');
      const turnOilType = this.$refs.customForm.getVal('turnOilType');
      if (!turnMonth) {
        this.$refs.customForm.setVal('canTurnMoneyDouble', 0);
        this.$refs.customForm.setVal('orderMoneyDouble', 0);
        this.$refs.customForm.setVal('consumeMoneyDouble', 0);
        this.$refs.customForm.setVal('turnDiscountDouble', 0);
        return;
      }
      const res = await queryDriverAccountBalance({
        userId: this.originData.userId,
        userType: this.originData.userType,
        turnType,
        turnOilType,
        month: this.formatDate(turnMonth, 3),
      });
      this.$refs.customForm.setVal('canTurnMoneyDouble', res.canTurnMoneyDouble);
      this.$refs.customForm.setVal('orderMoneyDouble', res.orderMoneyDouble);
      this.$refs.customForm.setVal('consumeMoneyDouble', res.consumeMoneyDouble);
      this.$refs.customForm.setVal('turnDiscountDouble', res.turnDiscountDouble);

    },
    handleTurnTypeChange () { // 类型切换
      const turnType = this.$refs.customForm.getVal('turnType');
      const turnOilType = this.$refs.customForm.getVal('turnOilType');
      this.setFormAttrVal({
        form: this.formData,
        attr: 'hide',
        value: turnType !== 1 || turnOilType !== 2,
        names: [
          'turnEntityOilCard',
        ],
      });
      this.setFormAttrVal({
        form: this.formData,
        attr: 'label',
        value: turnType === 1 ? '订单油卡总金额' : '订单ETC总金额',
        names: [
          'orderMoneyDouble',
        ],
      });
      if (turnType === 1) {
        this.formData.turnOilTypeOptions = [
          {
            label: '转现金',
            value: 1,
          },
          {
            label: '转油卡',
            value: 2,
          },
        ];
      } else {
        this.$refs.customForm.setVal('turnOilType', 1);
        this.formData.turnOilTypeOptions = [
          {
            label: '转现金',
            value: 1,
          },
        ];
      }
      this.$refs.customForm.setVal('turnMonth', null);
      this.handleTurnMonthChange();
    },

    handleTurnOilTypeChange () { // 转移方式
      const turnOilType = this.$refs.customForm.getVal('turnOilType');
      this.setFormAttrVal({
        form: this.formData,
        attr: 'hide',
        value: turnOilType !== 2,
        names: [
          'turnEntityOilCard',
        ],
      });
    },

    /**
     * @param {Object} item 修改的项
     * @returns {void}
     * @description 打开弹窗并初始化数据
     */
    show (item) {
      this.dialogFormVisible = true; // 打开弹窗
      this.$nextTick(() => {
        this.$refs.customForm.reset();
        this.originData = item;
      });
    },

    customFormPost () {
      this.$refs.customForm.sub();
    },

    /**
     * @param {Object} form 表单数据
     * @returns {void}
     * @description 弹窗确定按钮事件
     */
    async sub (form) {
      this.subLoading = true;
      form.turnMonth = this.formatDate(form.turnMonth, 3);
      form.turnBalance = form.turnBalance * 100;
      form.turnDiscountDouble = form.turnDiscountDouble * 10000;
      const res = await driverBalanceTurn({
        ...form,
        userId: this.originData.userId,
        userType: this.originData.userType,
      });
      this.subLoading = false;
      if (!res.failed) {
        this.dialogFormVisible = false; // 关闭弹窗
        this.$message({
          type: 'success',
          message: '保存成功',
        });
        this.$emit('sub');
      }
    },
  },
};
</script>

<style>
</style>
